import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const bgImage = 'https://images.pexels.com/photos/8353783/pexels-photo-8353783.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div
        className="relative w-full h-[560px] md:h-[640px] bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 max-w-6xl mx-auto px-6 h-full flex flex-col items-center justify-center text-center">
          <h1 className="text-white font-extrabold leading-tight drop-shadow-lg text-4xl md:text-6xl tracking-tight">
            Custom Web Design &amp; Development
            <span className="block mt-2">— Websites Built to Convert.</span>
          </h1>
          <Link
            to="/contact"
            className="mt-10 inline-block bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold px-8 py-4 rounded-md text-lg tracking-wide shadow-lg hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5"
          >
            Get a Free Estimate
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
